import request from './axiosFun'; // 有 loading
import apiHttp from './apiHttp'; // 无 loading
// 人员列表
var url = '';
if (process.env.NODE_ENV === 'development') {
  url = '/est';
} else {
  url = '';
}

// 产品分页查询
export function queryPageList(data) {
  return request({
    url: url + '/finance/productInfo/queryPageList',
    method: 'post',
    data
  });
}
// 产品分页查询（多选）
export function queryProductList(data) {
  return request({
    url: url + '/finance/productInfo/queryProductList',
    method: 'post',
    data
  });
}
// 添加产品
export function addProduct(data) {
  return apiHttp({
    url: url + '/finance/productInfo/addProduct',
    method: 'post',
    data
  });
}
// 删除产品信息
export function deleteProduct(data) {
  return apiHttp({
    url: url + '/finance/productInfo/delete',
    method: 'post',
    data
  });
}
// 修改产品信息
export function updProduct(data) {
  return apiHttp({
    url: url + '/finance/productInfo/updProduct',
    method: 'post',
    data
  });
}
// 修改产品信息(状态)
export function reviewPdt(data) {
  return apiHttp({
    url: url + '/finance/productInfo/reviewPdt',
    method: 'post',
    data
  });
}
// 贷后补录
export function saveSupplementFinance(data) {
  return request({
    url: url + '/finance/tradeInfo/saveSupplementFinance',
    method: 'post',
    data
  });
}
// 机构端需求管理需求大厅列表
export function findPushRequirementInfoList(data) {
  return request({
    url: url + '/finance/requirementInfoInstitutionPc/findPushRequirementInfoList',
    method: 'post',
    data
  });
}
// 机构端需求管理已推送列表
export function findInstitutionPushRequirementList(data) {
  return request({
    url: url + '/finance/requirementInfoInstitutionPc/findInstitutionPushRequirementList',
    method: 'post',
    data
  });
}
// 机构推送产品给用户
export function institutionPushProduct(data) {
  return apiHttp({
    url: url + '/finance/applyOrder/institutionPushProduct',
    method: 'post',
    data
  });
}
// 银行审核
export function institutionApply(data) {
  return apiHttp({
    url: url + '/finance/applyOrder/institutionApply',
    method: 'post',
    data
  });
}
// 提交回执单
export function submitOfflineTrade(data) {
  return apiHttp({
    url: url + '/finance/tradeInfo/submitOfflineTrade',
    method: 'post',
    data
  });
}
// 机构端查詢用戶牧場列表
export function findUserFarmList(data) {
  return request({
    url: url + '/finance/financeForUser/findUserFarmList',
    method: 'post',
    data
  });
}
// 选择抵押物-可抵押的畜只列表
export function findAllowPledgeLivestockList(data) {
  return request({
    url: url + '/finance/collateralInfo/findAllowPledgeLivestockList',
    method: 'post',
    data
  });
}
// 获取抵押物畜只详情
export function queryCollateralLivestockPage(data) {
  return request({
    url: url + '/finance/tradeInfo/queryCollateralLivestockPage',
    method: 'post',
    data
  });
}
// PC端首页订单申请统计
export function statisticsApplyOrder(data) {
  return apiHttp({
    url: url + '/finance/applyOrder/statisticsApplyOrder',
    method: 'post',
    data
  });
}
// 银行机构端PC首页需求数量统计
export function findInstitutionPcHomeRequirementCount(data) {
  return apiHttp({
    url: url + '/finance/requirementInfoInstitutionPc/findInstitutionPcHomeRequirementCount',
    method: 'post',
    data
  });
}
// 产品主页统计
export function queryProductStatistical(data) {
  return request({
    url: url + '/finance/productInfo/queryProductStatistical',
    method: 'post',
    data
  });
}
// 首页消息列表
export function queryNoticeInfoPage(data) {
  return request({
    url: url + '/finance/info/queryNoticeInfoPage',
    method: 'post',
    data
  });
}
// 删除该用户所有消息
export function deleteUserNoticeInfo(data) {
  return apiHttp({
    url: url + '/finance/info/deleteUserNoticeInfo',
    method: 'post',
    data
  });
}
// 设置告警值
export function updateAlarmThresholdCount(data) {
  return apiHttp({
    url: url + '/finance/settingInfo/updateAlarmThresholdCount',
    method: 'post',
    data
  });
}
// 根据圈舍信息查询畜只的智能耳标等信息
export function findByLivestockList(data) {
  return request({
    url: url + '/livestock/livestockInfo/findByLivestockList',
    method: 'post',
    data
  });
}
// 下载pdf
export function downloadNetFile(data) {
  return request({
    url: url + '/finance/tradeCollateralInfo/downloadNetFile',
    method: 'post',
    data
  });
}
// 验证机构贷款撮合时间是否已到期
export function checkInstitutionLoanPushLimitTime(data) {
  return apiHttp({
    url: url + '/finance/institutionInfo/checkInstitutionLoanPushLimitTime',
    method: 'post',
    data
  });
}
// 验证机构贷后监管查看信息时间是否已到期
export function checkInstitutionLoanInfoLimitTime(data) {
  return apiHttp({
    url: url + '/finance/institutionInfo/checkInstitutionLoanInfoLimitTime',
    method: 'post',
    data
  });
}
// 监管端PC首页需求数量统计
export function findAdminPcHomeRequirementCount(data) {
  return apiHttp({
    url: url + '/finance/requirementInfoAdminPc/findAdminPcHomeRequirementCount',
    method: 'post',
    data
  });
}
// 查看资产畜只数量历史记录统计列表
export function findPropertyLivestockCountList(data) {
  return apiHttp({
    url: url + '/finance/financeFarmRecord/findPropertyLivestockCountList',
    method: 'post',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/loanaidinstitutions.js